/* =========================================================
   FURSEUM — theme.js
   ========================================================= */
(function () {
  'use strict';

  document.documentElement.classList.remove('no-js');

  /* ---------------- Mobile nav ---------------- */
  var menuToggle = document.querySelector('[data-menu-toggle]');
  var mobileNav = document.querySelector('[data-mobile-nav]');
  var mobileNavClose = document.querySelector('[data-mobile-nav-close]');
  function openMobileNav() {
    if (!mobileNav) return;
    mobileNav.classList.add('is-open');
    mobileNav.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }
  function closeMobileNav() {
    if (!mobileNav) return;
    mobileNav.classList.remove('is-open');
    mobileNav.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }
  if (menuToggle) menuToggle.addEventListener('click', openMobileNav);
  if (mobileNavClose) mobileNavClose.addEventListener('click', closeMobileNav);

  /* ---------------- Cart drawer ---------------- */
  var cartDrawer = document.querySelector('[data-cart-drawer]');
  var cartOverlay = document.querySelector('[data-cart-overlay]');
  var cartTriggers = document.querySelectorAll('[data-cart-trigger]');
  var cartCloseBtns = document.querySelectorAll('[data-cart-close]');

  function renderMoney(cents, format) {
    var value = cents / 100;
    var amount = value.toFixed(2);
    var amountNoDecimals = Math.round(value).toString();
    var fmt = format || window.themeMoneyFormat || '${{amount}}';
    return fmt
      .replace('{{amount_no_decimals_with_comma_separator}}', amountNoDecimals.replace(/\B(?=(\d{3})+(?!\d))/g, '.'))
      .replace('{{amount_with_comma_separator}}', amount.replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, '.'))
      .replace('{{amount_no_decimals}}', amountNoDecimals)
      .replace('{{amount}}', amount);
  }
  function moneyShort(cents) {
    return renderMoney(cents).replace(/([.,])00\b/, '');
  }

  function renderShippingBar(cart) {
    var bar = document.querySelector('[data-cart-shipping-bar]');
    if (!bar) return;
    var threshold = parseInt(bar.getAttribute('data-threshold'), 10);
    if (!threshold) return;

    var textEl = bar.querySelector('[data-cart-shipping-text]');
    var fillEl = bar.querySelector('[data-cart-shipping-fill]');
    var remaining = threshold - cart.total_price;
    var progress = Math.min(100, (cart.total_price / threshold) * 100);

    if (fillEl) fillEl.style.width = progress + '%';

    if (textEl) {
      if (remaining <= 0) {
        textEl.textContent = bar.getAttribute('data-success-text') || "You've unlocked free shipping!";
        bar.classList.add('is-complete');
      } else {
        var template = bar.getAttribute('data-message-template') || "You're [amount] away from free shipping!";
        textEl.textContent = template.replace('[amount]', renderMoney(remaining));
        bar.classList.remove('is-complete');
      }
    }
  }

  function renderCartDrawer(cart) {
    var itemsEl = document.querySelector('[data-cart-items]');
    var subtotalEl = document.querySelector('[data-cart-subtotal]');
    var countEls = document.querySelectorAll('[data-cart-count]');
    var emptyEl = document.querySelector('[data-cart-empty]');
    if (!itemsEl) return;

    renderShippingBar(cart);

    countEls.forEach(function (el) { el.textContent = cart.item_count; });

    if (cart.item_count === 0) {
      itemsEl.innerHTML = '';
      if (emptyEl) emptyEl.style.display = 'block';
    } else {
      if (emptyEl) emptyEl.style.display = 'none';
      itemsEl.innerHTML = cart.items.map(function (item) {
        var props = '';
        if (item.properties) {
          Object.keys(item.properties).forEach(function (key) {
            var val = item.properties[key];
            if (!val || key.indexOf('_') === 0) return;
            var display = (typeof val === 'string' && val.indexOf('/uploads/') !== -1) ? 'Photo attached' : val;
            props += '<div class="cart-line__props">' + key + ': ' + display + '</div>';
          });
        }
        return (
          '<div class="cart-line" data-cart-line="' + item.key + '">' +
            '<img src="' + (item.image ? item.image.replace('{width}', '150') : '') + '" alt="' + item.product_title + '" loading="lazy">' +
            '<div>' +
              '<div class="product-card__title">' + item.product_title + '</div>' +
              (item.variant_title ? '<div class="cart-line__props">' + item.variant_title + '</div>' : '') +
              props +
              '<div class="flex-between" style="margin-top:.5rem;gap:1rem;">' +
                '<span>Qty ' + item.quantity + '</span>' +
                '<span>' + renderMoney(item.final_line_price) + '</span>' +
              '</div>' +
              '<button class="cart-line__remove" data-cart-remove="' + item.key + '">Remove</button>' +
            '</div>' +
          '</div>'
        );
      }).join('');
    }
    if (subtotalEl) subtotalEl.textContent = renderMoney(cart.total_price);
  }

  function fetchCart() { return fetch('/cart.js').then(function (r) { return r.json(); }); }
  function refreshCart() { return fetchCart().then(renderCartDrawer); }

  function openCartDrawer() {
    if (!cartDrawer) return;
    refreshCart();
    cartDrawer.classList.add('is-open');
    if (cartOverlay) cartOverlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }
  function closeCartDrawer() {
    if (!cartDrawer) return;
    cartDrawer.classList.remove('is-open');
    if (cartOverlay) cartOverlay.classList.remove('is-open');
    document.body.style.overflow = '';
  }
  cartTriggers.forEach(function (btn) {
    btn.addEventListener('click', function (e) { e.preventDefault(); openCartDrawer(); });
  });
  cartCloseBtns.forEach(function (btn) { btn.addEventListener('click', closeCartDrawer); });
  if (cartOverlay) cartOverlay.addEventListener('click', closeCartDrawer);

  document.addEventListener('click', function (e) {
    var removeBtn = e.target.closest('[data-cart-remove]');
    if (!removeBtn) return;
    e.preventDefault();
    var key = removeBtn.getAttribute('data-cart-remove');
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: 0 })
    }).then(function (r) { return r.json(); }).then(function (cart) {
      renderCartDrawer(cart);
      if (window.location.pathname === '/cart') window.location.reload();
    });
  });

  /* ---------------- Add-to-cart forms ---------------- */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-product-form]');
    if (!form) return;

    var fileInputs = form.querySelectorAll('input[type="file"][data-required-upload]');
    var blocked = false;
    fileInputs.forEach(function (input) {
      var wrap = input.closest('.upload-field');
      if (input.hasAttribute('required') && input.files.length === 0) {
        blocked = true;
        if (wrap) wrap.classList.add('has-error');
      } else if (wrap) {
        wrap.classList.remove('has-error');
      }
    });
    if (blocked) { e.preventDefault(); return; }

    e.preventDefault();
    var submitBtn = form.querySelector('[type="submit"]');
    var originalLabel = submitBtn ? submitBtn.textContent : '';
    if (submitBtn) { submitBtn.setAttribute('disabled', 'disabled'); submitBtn.textContent = 'Adding…'; }

    var formData = new FormData(form);
    fetch('/cart/add.js', { method: 'POST', body: formData })
      .then(function (r) {
        if (!r.ok) return r.json().then(function (err) { throw err; });
        return r.json();
      })
      .then(function () {
        if (settingsCartType() === 'drawer') { openCartDrawer(); }
        else { window.location.href = '/cart'; }
      })
      .catch(function () { form.submit(); })
      .finally(function () {
        if (submitBtn) { submitBtn.removeAttribute('disabled'); submitBtn.textContent = originalLabel; }
      });
  });

  function settingsCartType() {
    return document.body.className.indexOf('cart-type-drawer') !== -1 ? 'drawer' : 'page';
  }

  /* ---------------- File upload UX ---------------- */
  function handleUploadChange(e) {
    var input = e.target;
    if (input.type !== 'file' || !input.closest('.upload-field')) return;
    var wrap = input.closest('.upload-field');
    var confirmEl = wrap.querySelector('[data-upload-confirm]');
    var nameEl = wrap.querySelector('[data-upload-filename]');
    var previewEl = wrap.querySelector('[data-upload-preview]');
    var iconEl = wrap.querySelector('[data-upload-icon]');

    if (input.files && input.files[0]) {
      var file = input.files[0];
      wrap.classList.add('is-filled');
      wrap.classList.remove('has-error');
      if (confirmEl) confirmEl.hidden = false;
      if (nameEl) nameEl.textContent = 'Uploaded: ' + file.name;

      if (previewEl && file.type && file.type.indexOf('image/') === 0) {
        var url = URL.createObjectURL(file);
        previewEl.src = url;
        previewEl.hidden = false;
        previewEl.onload = function () { URL.revokeObjectURL(url); };
        if (iconEl) iconEl.hidden = true;
      }
    } else {
      wrap.classList.remove('is-filled');
      if (confirmEl) confirmEl.hidden = true;
      if (nameEl) nameEl.textContent = '';
      if (previewEl) { previewEl.hidden = true; previewEl.removeAttribute('src'); }
      if (iconEl) iconEl.hidden = false;
    }
  }
  document.addEventListener('change', handleUploadChange);
  document.addEventListener('input', handleUploadChange);

  /* ---------------- Quantity steppers ---------------- */
  document.addEventListener('click', function (e) {
    var stepBtn = e.target.closest('[data-qty-step]');
    if (!stepBtn) return;
    var wrap = stepBtn.closest('.qty-input');
    var input = wrap && wrap.querySelector('input[type="number"]');
    if (!input) return;
    var dir = stepBtn.getAttribute('data-qty-step') === 'up' ? 1 : -1;
    var next = Math.max(1, (parseInt(input.value, 10) || 1) + dir);
    input.value = next;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------------- Product gallery thumbnails ---------------- */
  document.addEventListener('click', function (e) {
    var thumb = e.target.closest('[data-thumb-src]');
    if (!thumb) return;
    var gallery = thumb.closest('[data-product-gallery]');
    if (!gallery) return;
    var mainImg = gallery.querySelector('[data-gallery-main-img]');
    if (mainImg) mainImg.src = thumb.getAttribute('data-thumb-src');
    gallery.querySelectorAll('[data-thumb-src]').forEach(function (b) { b.classList.remove('is-active'); });
    thumb.classList.add('is-active');
  });

  /* ---------------- Background-colour picker ---------------- */
  document.addEventListener('click', function (e) {
    var bgSwatch = e.target.closest('[data-bg-swatch]');
    if (!bgSwatch) return;
    var grid = bgSwatch.closest('.bg-swatch-grid');
    if (grid) grid.querySelectorAll('.bg-swatch').forEach(function (s) { s.classList.remove('is-selected'); });
    bgSwatch.classList.add('is-selected');
    var field = bgSwatch.closest('.field');
    var input = field && field.querySelector('[data-bg-swatch-input]');
    if (input) input.value = bgSwatch.getAttribute('data-bg-swatch');
  });

  /* ---------------- Variant swatches: id, price, +$ step-ups, payment terms ---------------- */
  function variantMatch(variants, opts) {
    return variants.find(function (v) {
      return v.options.length === opts.length && v.options.every(function (o, i) { return o === opts[i]; });
    });
  }

  function currentSelections(form) {
    var sel = [];
    form.querySelectorAll('[data-option-group]').forEach(function (g) {
      var active = g.querySelector('.swatch.is-selected');
      sel.push(active ? active.getAttribute('data-variant-option') : null);
    });
    return sel;
  }

  function updateSwatchDeltas(form) {
    var vj = form.querySelector('[data-variants-json]');
    if (!vj) return;
    var variants;
    try { variants = JSON.parse(vj.textContent); } catch (err) { return; }
    var sel = currentSelections(form);
    var groups = form.querySelectorAll('[data-option-group]');

    groups.forEach(function (g, gi) {
      var swatches = g.querySelectorAll('[data-variant-option]');
      var prices = [];
      swatches.forEach(function (sw) {
        var test = sel.slice();
        test[gi] = sw.getAttribute('data-variant-option');
        var m = variantMatch(variants, test);
        prices.push(m ? m.price : null);
      });
      var valid = prices.filter(function (p) { return p != null; });
      if (!valid.length) return;
      var baseline = Math.min.apply(null, valid);
      swatches.forEach(function (sw, i) {
        var deltaEl = sw.querySelector('[data-swatch-delta]');
        if (!deltaEl) return;
        var p = prices[i];
        if (p == null || p - baseline <= 0) { deltaEl.textContent = ''; }
        else { deltaEl.textContent = '+' + moneyShort(p - baseline); }
      });
    });
  }

  document.addEventListener('click', function (e) {
    var swatch = e.target.closest('[data-variant-option]');
    if (!swatch) return;
    var group = swatch.closest('[data-option-group]');
    if (group) group.querySelectorAll('.swatch').forEach(function (s) { s.classList.remove('is-selected'); });
    swatch.classList.add('is-selected');

    var form = swatch.closest('[data-product-form]');
    if (!form) return;

    var selections = currentSelections(form);
    var vj = form.querySelector('[data-variants-json]');
    if (!vj) return;
    var variants = JSON.parse(vj.textContent);
    var match = variantMatch(variants, selections);

    updateSwatchDeltas(form);
    if (!match) return;

    var scope = form.closest('.product') || document;
    var idInput = form.querySelector('input[name="id"]');
    var priceEl = scope.querySelector('[data-product-price]');
    var addBtn = form.querySelector('[data-add-to-cart]');

    if (idInput) idInput.value = match.id;

    var payTermsText = scope.querySelector('[data-payment-terms] .afterpay-badge__text');
    if (payTermsText) {
      var installment = Math.round(match.price / 4);
      payTermsText.textContent = 'or 4 payments of ' + renderMoney(installment) + ' with';
    }

    if (priceEl) {
      var html = renderMoney(match.price);
      if (match.compare_at_price && match.compare_at_price > match.price) {
        html = '<span class="compare-at">' + renderMoney(match.compare_at_price) + '</span>' + html;
      }
      priceEl.innerHTML = html;
    }

    if (addBtn) {
      addBtn.disabled = !match.available;
      addBtn.textContent = match.available
        ? addBtn.getAttribute('data-label-available')
        : addBtn.getAttribute('data-label-soldout');
    }
  });

  /* initial pass so the +$ labels are right on page load */
  document.querySelectorAll('[data-product-form]').forEach(function (form) {
    updateSwatchDeltas(form);
  });

})();